import cn from "classnames";
import BookShow from "components/shared/book/show";
import { Transition } from "components/shared/column";
import { GeoPicker } from "components/shared/form";
import Loader from "components/shared/loader";
import { getInitialStateFromConfig, serializeReq } from "helpers/form";
import { requiredField } from "helpers/validators";
import React from "react";
import { customConnect } from "./container";

const config = {
    tollBooth: {
        label: "Название ПВП",
        inputProps: { name: "tollBooth" },
        validators: [requiredField],
        required: true,
    },
    highway: {
        label: "Трасса",
        inputProps: { name: "highway" },
        validators: [requiredField],
        required: true,
    },
    location: {
        validators: [requiredField],
    },
};

const initialState = getInitialStateFromConfig(config);

class PaymentPointsShow extends BookShow {
    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        if (match.params.id) {
            source.getItem(match.params).then((data) => this.setState({ data, initial: data, ...defParams }));
        } else {
            this.setState(defParams);
        }
    };

    get dropdActions() {
        return [{ text: "Удалить", action: this.actionClose }];
    }

    apply = () => {
        const { source, match, back } = this.props;
        const { isLoading, shouldUpdate, ...state } = this.state;
        if (!isLoading && shouldUpdate) {
            if (this.isValidForm(state.data)) {
                this.setState({ isLoading: true, isValid: true });
                return source.apply(serializeReq({ ...match.params, ...state.data })).then((res) => {
                    if (res) {
                        match.params.id ? this.update() : back();
                    } else {
                        this.setState({ isLoading: false, isValid: false });
                    }
                });
            }
            this.setState({ isValid: false });
        }
    };

    renderButton = () => {
        if (!this.props.canEditBooks) {
            return null;
        }
        const cname = cn("btn btn-brand btn-sm", { disabled: !this.state.shouldUpdate });
        return (
            <div className="panel__row panel__row--button">
                <div className={cname} onClick={this.apply}>
                    {this.props.match.params.id ? "Обновить" : "Сохранить"}
                </div>
            </div>
        );
    };

    renderBody = () => {
        const { config, switchMap } = this.props;
        if (this.state.isLoading) {
            return <Loader prefix="absolute-center" />;
        }
        return (
            <>
                {this.renderField(config.tollBooth)}
                {this.renderField(config.highway)}
                <GeoPicker
                    withoutRadius
                    label="Координаты"
                    name="location"
                    switchMap={switchMap}
                    onChange={({ name, value }) =>
                        this.setValue({ name, value: { coordinates: value?.location?.coordinates } })
                    }
                    value={{
                        location: this.state.data.location || { coordinates: [] },
                        address: this.state.data.location?.coordinates?.join(", "),
                    }}
                    validators={[requiredField]}
                />
                {this.renderButton()}
            </>
        );
    };

    render() {
        const cname = cn("book-show__body", { "book-show__body--invalid": !this.state.isValid });
        return (
            <Transition dir="full">
                <div className="page-book__show book-show">
                    {this.renderHead()}
                    <div className={cname}>{this.renderBodyWrap()}</div>
                </div>
            </Transition>
        );
    }
}

const ConfiguredShow = (props) => <PaymentPointsShow {...props} config={config} initialState={initialState} />;

export default customConnect(ConfiguredShow);
